import PropTypes from 'prop-types'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/common/components/ui/dialog'
import { Button } from '@/common/components/ui/button'

const DeleteConfirmation = ({ employee, show, onConfirm, hideModal }) => (
  <Dialog open={show} onOpenChange={(open) => !open && hideModal()}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Delete Employee</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        Are you sure you want to remove <strong>{employee?.fullName}</strong>?
      </p>
      <DialogFooter>
        <Button variant="outline" onClick={hideModal}>Cancel</Button>
        <Button variant="destructive" onClick={onConfirm}>Delete</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

DeleteConfirmation.propTypes = {
  employee: PropTypes.shape({
    fullName: PropTypes.string,
  }),
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}

export default DeleteConfirmation
